export default __webpack_public_path__ + "static/media/arrow-down.8910eac6.svg";